<template>
    <div>
        <v-autocomplete
            v-model="step"
            :items="steps"
            item-value="name"
            item-text="name"
            :label="label"
            outlined
            dense
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details
            clearable
            @click:clear="clear"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref, watch} from "vue";
import axios from "axios";

export default {
    name: "StrWorkflowStepAutocomplete",
    props: {
        value: String,
        label: String,
        module: {
            type: String,
            required: true,
        },
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const step = ref(null);
        const steps = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/validationWorkFlows/steps/${props.module}`).then(response => {
                steps.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }


        function clear() {
            step.value = null;
        }

        onMounted(() => {
            findAll();
            step.value = props.value;
        });

        watch(step, () => {
            emit("input", step.value);
        });

        return {
            loading,
            inputColor,
            backgroundColor,
            step,
            steps,
            clear,
        }
    },
}
</script>

<style scoped>

</style>